import {create, DIV} from '@acng/frontend-bounty/dom/element.js';
import {popup} from '@acng/frontend-discovery';
import {localProvide} from '@acng/frontend-relativity';

import {layoutFeature} from '../config/feature.js';
import {ctxLightboxItem} from '../context/lightbox-item.js';
import {CLICK, on} from '@acng/frontend-bounty/dom/event.js';

/**
 * @param {string} url
 * @returns {Promise<void>}
 */
export const lightboxPopup = async (url) => {
  const div = create(DIV);
  const engine = await layoutFeature.render('lightbox-popup');

  on(div, CLICK, () => popup().close(div));
  localProvide(div, ctxLightboxItem, {type: 'img', src: url});
  await popup().show(engine.toElement(div));

  engine.disconnect();
};
